import { RoomScene } from './../RoomScene';
import { BananaSpine } from "./../banana/BananaSpine";
import { AudioManager } from "./../../../managers/AudioManager";
import { AvatarSpine } from "./SpineAvatar";
import { ChipsContainer } from "./ChipsContainer";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { RoomManager } from "../../../managers/RoomManager";
import { Bot } from "../bot/Bot";

export class AdversaryContainer extends Phaser.GameObjects.Container {

    public isDealer: boolean;
    public id: string;
    public positionInTable: number;
    public bot: Bot;
    public streak: number;

    private creditsLabel: Phaser.GameObjects.Text;
    private confetti: Phaser.GameObjects.Sprite;
    private sparks: Phaser.GameObjects.Sprite;
    private winstreak: Phaser.GameObjects.Sprite;
    private cards: Phaser.GameObjects.Image[];
    private frames: Phaser.GameObjects.Image[];
    private chipsContainer: ChipsContainer;
    private avatar: AvatarSpine;
    private avatarContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene, x: number, y: number, positionInTable: number, isPlayer: boolean, id: string) {

        super(scene);

        this.setScale(.9 * GameVars.scaleX, .9);

        this.x = x;
        this.y = y;
        this.id = id;
        this.isDealer = false;
        this.positionInTable = positionInTable;

        this.cards = [];
        this.frames = [];

        this.streak = 0;

        let rightSide = this.x > GameConstants.GAME_WIDTH / 2;

        this.confetti = this.scene.add.sprite(rightSide ? -80 : 80, 0, "texture_atlas_1", "confetti_01.png");
        this.add(this.confetti);

        this.confetti.on("animationcomplete", () => {
            this.confetti.visible = false;
        }, this);

        this.sparks = this.scene.add.sprite(rightSide ? -80 : 80, -10, "texture_atlas_1");
        this.sparks.visible = false;
        this.add(this.sparks);

        this.sparks.on("animationcomplete", () => {
            this.sparks.visible = false;
        }, this);

        // CONTAINER

        this.avatarContainer = new Phaser.GameObjects.Container(this.scene);
        this.avatarContainer.setInteractive(new Phaser.Geom.Rectangle(-110, -50, 220, 100), Phaser.Geom.Rectangle.Contains);

        if (this.scene.sys.game.device.os.desktop) {
            this.avatarContainer.on("pointerover", () => {
                RoomScene.currentInstance.showInfo(this.id);
            });
            this.avatarContainer.on("pointerout", () => {
                RoomScene.currentInstance.hideInfo();
            });
        } else {
            this.avatarContainer.on("pointerover", () => {
                RoomScene.currentInstance.showInfoMobile(this.id);
            });
        }

        this.add(this.avatarContainer);

        let capsule = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "capsule_rival.png");
        capsule.scaleX = rightSide ? -1 : 1;
        this.avatarContainer.add(capsule);


        const credits = RoomManager.getPlayer(id).chips;

        this.creditsLabel = new Phaser.GameObjects.Text(this.scene, rightSide ? 40 : -40, 17, GameVars.formatNumber(credits), { fontFamily: "Oswald-Medium", fontSize: "30px", color: "#8d8065" });
        this.creditsLabel.setOrigin(.5);
        this.avatarContainer.add(this.creditsLabel);

        let playerName = new Phaser.GameObjects.Image(this.scene, rightSide ? 40 : -40, -25, "texture_atlas_1", "name_" + this.id + ".png");
        playerName.setScale(.95);
        this.avatarContainer.add(playerName);

        // LOS CHIPS 
        this.chipsContainer = new ChipsContainer(this.scene, rightSide, isPlayer, this.id);
        this.chipsContainer.visible = false;
        this.add(this.chipsContainer);

        this.bot = new Bot(this.id);

        let avatarX = rightSide ? -90 : 90;

        this.avatar = new AvatarSpine(this.scene, rightSide ? -20 : 20, 50, this.id);
        this.avatar.scaleY = rightSide ? -1 : 1;
        this.add(this.avatar);

        avatarX += rightSide ? 18 : -18;

        this.alpha = 0;

        this.winstreak = this.scene.add.sprite(rightSide ? -80 : 80, -10, "texture_atlas_1");
        this.winstreak.visible = false;
        this.add(this.winstreak);

        this.winstreak.anims.play("winner_streak");
    }

    public updateChipsState(): void {

        this.chipsContainer.updateChipsState();
    }

    public eliminatePlayer(): void {

        let rightSide = this.x > GameConstants.GAME_WIDTH / 2;

        let banana = new BananaSpine(this.scene);
        banana.scaleY = rightSide ? -1 : 1;
        banana.x = rightSide ? -70 : 65;
        banana.y -= 160;
        this.add(banana);

        AudioManager.playSound("puf");

        banana.setAvatarState("eliminacion");

        let newX;
        let newY;

        if (this.x === GameConstants.GAME_WIDTH / 2 - 30) {
            newX = 0;
            newY = -500;
        } else if (rightSide) {
            newX = 500;
            newY = 0;
        } else {
            newX = -500;
            newY = 0;
        }

        this.scene.tweens.add({
            targets: [this.avatarContainer, this.cards[0], this.cards[1]],
            alpha: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 500 / GameVars.gameSpeed,
            delay: 1500 / GameVars.gameSpeed,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this.avatar,
                    x: this.avatar.x + newX,
                    y: this.avatar.y + newY,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500 / GameVars.gameSpeed
                });
            },
            onCompleteScope: this
        });

        this.scene.time.addEvent({
            delay: 3500 / GameVars.gameSpeed, callback: () => {
                this.parentContainer.remove(this);
            }, callbackScope: this
        });

    }

    public addWageredToPot(): void {

        if (this.chipsContainer.visible) {
            this.scene.tweens.add({
                targets: this.chipsContainer,
                x: (GameConstants.GAME_WIDTH / 2 - this.x) / (GameVars.scaleX * .9),
                y: (GameConstants.GAME_HEIGHT / 2 - this.y - 50) / .9,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: 250 / GameVars.gameSpeed,
                onComplete: () => {
                    this.chipsContainer.visible = false;
                },
                onCompleteScope: this
            });
        }
    }

    public potToPlayer(): void {

        this.chipsContainer.creditsLabel.setFill("#89E09D");

        this.chipsContainer.x = (GameConstants.GAME_WIDTH / 2 - this.x) / (GameVars.scaleX * .9);
        this.chipsContainer.y = (GameConstants.GAME_HEIGHT / 2 - this.y - 50) / .9;
        this.chipsContainer.visible = true;
        this.chipsContainer.alpha = 1;

        this.scene.tweens.add({
            targets: this.chipsContainer,
            x: 0,
            y: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250 / GameVars.gameSpeed,
            onComplete: () => {
                this.chipsContainer.visible = false;
                this.updateChips();
            },
            onCompleteScope: this
        });
    }

    public setTurn(value: boolean): void {

        let rightSide = this.x > GameConstants.GAME_WIDTH / 2;

        if (value) {

            this.avatarContainer.setScale(1.05);
            this.avatar.setScale(1.05, rightSide ? -1.05 : 1.05);

            this.scene.tweens.add({
                targets: this.cards[0],
                alpha: 0,
                x: rightSide ? this.cards[0].x - 40 : this.cards[0].x + 40,
                ease: Phaser.Math.Easing.Cubic.In,
                duration: 200 / GameVars.gameSpeed,
                onComplete: () => {

                    this.cards[0].x = rightSide ? this.cards[0].x - 120 : this.cards[0].x + 160;
                    this.cards[0].y = this.cards[0].y + 50;
                    this.cards[0].setScale(.6);
                    this.cards[0].angle = -10;
                    this.bringToTop(this.cards[0]);
                    AudioManager.playSound("cards_in");

                    this.scene.tweens.add({
                        targets: this.cards[0],
                        alpha: 1,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 200 / GameVars.gameSpeed,
                    });

                    this.avatar.setAvatarAnimation(2, "checkCards");
                },
                onCompleteScope: this
            });

            this.scene.tweens.add({
                targets: this.cards[1],
                alpha: 0,
                x: rightSide ? this.cards[1].x - 40 : this.cards[1].x + 40,
                ease: Phaser.Math.Easing.Cubic.In,
                duration: 200 / GameVars.gameSpeed,
                onComplete: () => {

                    this.cards[1].x = rightSide ? this.cards[1].x - 160 : this.cards[1].x + 120;
                    this.cards[1].y = this.cards[1].y + 50;
                    this.cards[1].setScale(.6);
                    this.cards[1].angle = 10;
                    this.bringToTop(this.cards[1]);

                    this.scene.tweens.add({
                        targets: this.cards[1],
                        alpha: 1,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 200 / GameVars.gameSpeed,
                    });
                },
                onCompleteScope: this
            });
        } else {

            this.avatarContainer.setScale(1);
            this.avatar.setScale(1, rightSide ? -1 : 1);

            this.scene.tweens.add({
                targets: this.cards[0],
                alpha: 0,
                x: rightSide ? this.cards[0].x + 40 : this.cards[0].x - 40,
                ease: Phaser.Math.Easing.Cubic.In,
                duration: 200 / GameVars.gameSpeed,
                onComplete: () => {

                    this.cards[0].x = rightSide ? this.cards[0].x + 120 : this.cards[0].x - 160;
                    this.cards[0].y = this.cards[0].y - 50;
                    this.cards[0].setScale(.7);
                    this.cards[0].angle = 0;
                    this.sendToBack(this.cards[0]);
                    AudioManager.playSound("cards_out");

                    this.scene.tweens.add({
                        targets: this.cards[0],
                        alpha: 1,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 200 / GameVars.gameSpeed,
                    });
                },
                onCompleteScope: this
            });

            this.scene.tweens.add({
                targets: this.cards[1],
                alpha: 0,
                x: rightSide ? this.cards[1].x + 40 : this.cards[1].x - 40,
                ease: Phaser.Math.Easing.Cubic.In,
                duration: 200 / GameVars.gameSpeed,
                onComplete: () => {

                    this.cards[1].x = rightSide ? this.cards[1].x + 160 : this.cards[1].x - 120;
                    this.cards[1].y = this.cards[1].y - 50;
                    this.cards[1].setScale(.7);
                    this.cards[1].angle = 0;
                    this.sendToBack(this.cards[1]);

                    this.scene.tweens.add({
                        targets: this.cards[1],
                        alpha: 1,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 200 / GameVars.gameSpeed,
                    });
                },
                onCompleteScope: this
            });
        }
    }

    public addCardsFrames(cards: any[]): void {

        let playerCards = RoomManager.getPlayer(this.id).cards;

        for (let i = 0; i < cards.length; i++) {
            if (playerCards[0] === (cards[i].value + cards[i].suit)) {

                const card = new Phaser.GameObjects.Image(this.scene, this.cards[0].x, this.cards[0].y, "texture_atlas_1", "frame_winner_hand.png");
                card.angle = this.cards[0].angle;
                card.setScale(this.cards[0].scaleX, this.cards[0].scaleY);
                this.add(card);
                this.frames.push(card);
            }

            if (playerCards[1] === (cards[i].value + cards[i].suit)) {

                const card = new Phaser.GameObjects.Image(this.scene, this.cards[1].x, this.cards[1].y, "texture_atlas_1", "frame_winner_hand.png");
                card.angle = this.cards[1].angle;
                card.setScale(this.cards[1].scaleX, this.cards[1].scaleY);
                this.add(card);
                this.frames.push(card);
            }
        }

        this.bringToTop(this.cards[1]);

        if (this.frames.length > 0 && playerCards[1] === this.frames[0].name) {
            this.bringToTop(this.frames[0]);
        } else if (this.frames.length > 1 && playerCards[1] === this.frames[1].name) {
            this.bringToTop(this.frames[1]);
        }

        this.bringToTop(this.cards[0]);

        if (this.frames.length > 0 && playerCards[0] === this.frames[0].name) {
            this.bringToTop(this.frames[0]);
        } else if (this.frames.length > 1 && playerCards[0] === this.frames[1].name) {
            this.bringToTop(this.frames[1]);
        }
    }

    public addAdversaryHiddenCards(): void {

        this.bot.generateInitialValues();

        let rightSide = this.x > GameConstants.GAME_WIDTH / 2;
        let off = rightSide ? 25 : -25;

        const card1 = new Phaser.GameObjects.Image(this.scene, (GameConstants.GAME_WIDTH / 2 - this.x) / (GameVars.scaleX * .9), (GameConstants.GAME_HEIGHT / 2 - this.y + 15) / .9, "texture_atlas_2", "card-back.png");
        card1.setScale(.9);
        card1.alpha = 0;
        this.add(card1);
        this.cards.push(card1);

        const card2 = new Phaser.GameObjects.Image(this.scene, (GameConstants.GAME_WIDTH / 2 - this.x) / (GameVars.scaleX * .9), (GameConstants.GAME_HEIGHT / 2 - this.y + 15) / .9, "texture_atlas_2", "card-back.png");
        card2.setScale(.9);
        card2.alpha = 0;
        this.add(card2);
        this.cards.push(card2);

        this.sendToBack(card1);
        this.sendToBack(card2);

        let delay = RoomManager.getPlayer(this.id).position * 200;

        this.scene.tweens.add({
            targets: card1,
            x: -32 + off,
            y: -40,
            scaleX: .7,
            scaleY: .7,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 250 / GameVars.gameSpeed,
            delay: delay / GameVars.gameSpeed,
            onComplete: () => {
                AudioManager.playSound("card_reveal_" + (Math.floor(Math.random() * 3) + 1));
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: card2,
            x: 32 + off,
            y: -40,
            scaleX: .7,
            scaleY: .7,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 250 / GameVars.gameSpeed,
            delay: (delay + 100) / GameVars.gameSpeed,
            onComplete: () => {
                AudioManager.playSound("card_reveal_" + (Math.floor(Math.random() * 3) + 1));
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: card1,
            alpha: 1,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 100 / GameVars.gameSpeed,
            delay: delay / GameVars.gameSpeed
        });

        this.scene.tweens.add({
            targets: card2,
            alpha: 1,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 100 / GameVars.gameSpeed,
            delay: (delay + 100) / GameVars.gameSpeed
        });
    }

    public setDealer(isDealer: boolean): void {

        this.isDealer = isDealer;
    }

    public updateBet(type?: string): void {

        const player = RoomManager.getPlayer(this.id);

        if (player.wagered > 0) {
            this.chipsContainer.show();
            this.chipsContainer.setCredits(player.wagered + player.poted);

            if (player) {
                const credits = player.chips - player.wagered;
                this.creditsLabel.text = GameVars.formatNumber(credits);
            }
        }

        if (type) {

            this.creditsLabel.text = type.replace("_", " ").toUpperCase();
            switch (type) {
                case GameConstants.CALL:
                case GameConstants.CHECK:
                    this.creditsLabel.setFill("#ECA62F");
                    break;
                case GameConstants.FOLD:
                    this.creditsLabel.setFill("#22A6BD");
                    break;
                case GameConstants.RAISE:
                case GameConstants.ALL_IN:
                    this.creditsLabel.setFill("#DA314F");
                    break;
                default:
                    break;
            }

            if (type === GameConstants.ALL_IN) {

                let rightSide = this.x > GameConstants.GAME_WIDTH / 2;

                let fire = this.scene.add.sprite(this.avatar.x + (rightSide ? - 60 : 60), -60, "texture_atlas_1", "fire_raise_00.png");
                fire.anims.play("fire_raise");
                fire.setScale(1.2);
                this.add(fire);

                AudioManager.playSound("all_in_fire_fx");

                fire.on("animationcomplete", () => {
                    fire.destroy();
                }, this);
            }

            if (type === GameConstants.CHECK) {
                if (GameVars.gameSpeed === GameConstants.INITIAL_SPEED) {
                    AudioManager.playSound(type + "_" + this.id);
                }
                this.avatar.checkAnimation();
            } else {
                if (GameVars.gameSpeed === GameConstants.INITIAL_SPEED) {
                    AudioManager.playSound(type + "_" + (Math.floor(Math.random() * 2) + 1));
                }
            }

            this.scene.time.addEvent({
                delay: 1000 / GameVars.gameSpeed, callback: () => {

                    let player = RoomManager.getPlayer(this.id);

                    if (player) {
                        const credits = player.chips - player.wagered;
                        this.creditsLabel.text = GameVars.formatNumber(credits);
                        this.creditsLabel.setFill("#8d8065");
                    }
                }, callbackScope: this
            });
        }

        this.avatar.setAvatarAnimation(2, "blink");
    }

    public updateChips(): void {

        let player = RoomManager.getPlayer(this.id);

        if (player) {
            const credits = player.chips - player.wagered;
            this.creditsLabel.text = GameVars.formatNumber(credits);
        }
    }

    public resetBet(): void {

        // this.chipsContainer.hide();

        this.addWageredToPot();

        let player = RoomManager.getPlayer(this.id);

        if (player) {
            const credits = player.chips - player.wagered;
            this.creditsLabel.text = GameVars.formatNumber(credits);
        }
    }

    public inactive(): void {

        AudioManager.playSound("cards_out");

        let rightSide = this.x > GameConstants.GAME_WIDTH / 2;

        this.avatarContainer.setScale(.95);
        this.avatar.setScale(.95, rightSide ? -.95 : .95);

        this.avatarContainer.alpha = .5;

        this.scene.tweens.add({
            targets: this.cards,
            alpha: 0,
            scaleX: .6,
            scaleY: .6,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250 / GameVars.gameSpeed,
            onComplete: () => {
                this.remove(this.cards[0]);
                this.remove(this.cards[1]);
                this.cards = [];
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: this.cards[0],
            y: this.cards[0].y + 30,
            x: rightSide ? this.cards[0].x - 30 : this.cards[0].x + 30,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 200 / GameVars.gameSpeed
        });

        this.scene.tweens.add({
            targets: this.cards[1],
            y: this.cards[1].y + 30,
            x: rightSide ? this.cards[1].x - 30 : this.cards[1].x + 30,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 200 / GameVars.gameSpeed
        });
    }

    public showWinner(playerWinner: boolean): void {

        this.streak++;

        if (this.streak === 3) {
            this.winstreak.visible = true;
        }

        if (GameVars.allin && RoomManager.playersActive().length > 1) {
            this.sparks.visible = true;
            this.sparks.anims.play("sparks");
        }

        // this.winnerRibbon.visible = true;
        this.avatar.winAnimation();

        this.confetti.visible = true;
        this.confetti.anims.play("confetti", true);

        AudioManager.playSound("confetti");

        if (RoomManager.playersActive().length > 1) {

            if (!playerWinner) {
                AudioManager.playSound("rival_wins_hand");
            }

            this.scene.tweens.add({
                targets: this,
                scaleX: GameVars.scaleX,
                scaleY: 1,
                ease: Phaser.Math.Easing.Bounce.Out,
                duration: 500,
                onComplete: () => {
                    this.scene.tweens.add({
                        targets: this,
                        scaleX: .9 * GameVars.scaleX,
                        scaleY: .9,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 500,
                        delay: 500
                    });
                },
                onCompleteScope: this
            });
        }
    }

    public showLoser(): void {

        this.avatar.setTempState("bucle-enfado");

        this.streak = 0;
        this.winstreak.visible = false;
    }

    public showAdversaryCards(): void {

        if (this.cards[0].y === 40) {
            return;
        }

        let cards = RoomManager.getPlayer(this.id).cards;

        let position = 0;
        for (let i = 0; i < GameVars.gameState.players.length; i++) {
            if (this.id === GameVars.gameState.players[i].id) {
                break;
            } else {
                position++;
            }
        }

        // this.adversaryCards[0].y = -60;
        // this.adversaryCards[1].y = -60;

        this.scene.tweens.add({
            targets: this.cards[0],
            y: -100,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 250 / GameVars.gameSpeed,
            delay: (position * 100) / GameVars.gameSpeed,
            onComplete: () => {

                this.bringToTop(this.cards[0]);

                this.scene.tweens.add({
                    targets: this.cards[0],
                    scaleX: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 100 / GameVars.gameSpeed,
                    onComplete: () => {
                        this.cards[0].setFrame(GameVars.cardFrameName(cards[0]) + ".png");
                        AudioManager.playSound("card_reveal_" + (Math.floor(Math.random() * 3) + 1));
                    },
                    onCompleteScope: this
                });

                this.scene.tweens.add({
                    targets: this.cards[0],
                    scaleX: .6,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 100 / GameVars.gameSpeed,
                    delay: 100 / GameVars.gameSpeed
                });

                this.scene.tweens.add({
                    targets: this.cards[0],
                    scaleY: .6,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 200 / GameVars.gameSpeed,
                });

                this.scene.tweens.add({
                    targets: this.cards[0],
                    y: 40,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 350 / GameVars.gameSpeed,
                });

                this.scene.tweens.add({
                    targets: this.cards[0],
                    x: this.cards[0].x + 10,
                    angle: -10,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 350 / GameVars.gameSpeed,
                });
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: this.cards[1],
            y: -100,
            ease: Phaser.Math.Easing.Cubic.In,
            duration: 250 / GameVars.gameSpeed,
            delay: (250 + (position * 100)) / GameVars.gameSpeed,
            onComplete: () => {

                this.bringToTop(this.cards[1]);

                this.scene.tweens.add({
                    targets: this.cards[1],
                    scaleX: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 100 / GameVars.gameSpeed,
                    onComplete: () => {
                        this.cards[1].setFrame(GameVars.cardFrameName(cards[1]) + ".png");
                    },
                    onCompleteScope: this
                });

                this.scene.tweens.add({
                    targets: this.cards[1],
                    scaleX: .6,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 100 / GameVars.gameSpeed,
                    delay: 100 / GameVars.gameSpeed
                });

                this.scene.tweens.add({
                    targets: this.cards[1],
                    scaleY: .6,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 200 / GameVars.gameSpeed,
                });

                this.scene.tweens.add({
                    targets: this.cards[1],
                    y: 40,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 350 / GameVars.gameSpeed,
                });

                this.scene.tweens.add({
                    targets: this.cards[1],
                    x: this.cards[1].x - 10,
                    angle: 10,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 350 / GameVars.gameSpeed,
                });
            },
            onCompleteScope: this
        });
    }

    public decideShowAdversaryCards(): boolean {

        if (this.bot.attributes.aggressiveness < Math.random() * 100) {
            this.showAdversaryCards();
            return true;
        }

        return false;
    }

    public reactionCardsShown(): void {

        if (this.bot.attributes.aggressiveness < Math.random() * 100) {
            this.showLoser();
        }
    }

    public resetTable(): void {

        if (this.cards.length) {

            this.scene.tweens.add({
                targets: this.cards,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 200 / GameVars.gameSpeed,
                onComplete: () => {
                    this.remove(this.cards[0]);
                    this.remove(this.cards[1]);

                    this.cards = [];
                },
                onCompleteScope: this
            });

        }

        for (let i = 0; i < this.frames.length; i++) {
            this.remove(this.frames[i]);
        }
        this.frames = [];

        this.confetti.visible = false;
        this.avatarContainer.alpha = 1;
        this.resetBet();

        this.setScale(.9 * GameVars.scaleX, .9);

        this.avatar.calculateAvatarState(RoomManager.getPlayer(this.id).chips);
    }

    public bluffAnimation(): void {

        this.avatar.bluffAnimation();
        this.avatar.setAvatarAnimation(3, "tic-sudor");
    }

    public decisionAnimation(): void {

        let cards = GameVars.gameState.community.concat(RoomManager.getPlayer(this.id).cards);

        // if (Hand.solve(cards).name !== "High Card") {
        //     this.avatar.setAvatarAnimation(2, "saltito");
        // }

    }
}
